import { computed, onMounted, ref } from 'vue'
import {
	atualizarConfiguracoesDoAplicativo,
	buscarConfiguracoesDoAplicativo,
} from '../services/requests/ConfiguracaoAplicativoRequests'
import { useMessages } from './useMessages'

const { addMessage } = useMessages()

const idConfiguracao = ref(undefined)

const inventario = ref({
	config_app_tx_mdco_tpmd: undefined,
	config_app_yn_mdco_arvs_count: false,
	config_app_nr_mdco_nrcd: undefined,
	config_app_tx_tipo_intensidade: undefined,
})

const cubagem = ref({
	config_app_tx_cbgm_tpmd: undefined,
	config_app_nr_cbgm_nrcd: undefined,
})

const pilha = ref({
	config_app_tx_pilha_tpmd: undefined,
	config_app_nr_numero_de_casas_decimais: undefined,
	config_app_nr_numero_de_diametros_obrigatorio: undefined,
	config_app_nr_altura_maxima: undefined,
	config_app_nr_altura_minima: undefined,
	config_app_nr_largura_maxima: undefined,
	config_app_nr_largura_minima: undefined,
	config_app_diametro_maximo: undefined,
	config_app_diametro_minimo: undefined,
})

export const useConfiguracoesAplicativo = () => {
	const updating = ref(false)

	const configuracao = computed(() => {
		return {
			id: idConfiguracao.value,
			...inventario.value,
			...cubagem.value,
			...pilha.value,
		}
	})

	function atualizarConfiguracoes() {
		updating.value = true
		atualizarConfiguracoesDoAplicativo(configuracao.value)
			.then(() => {
				updating.value = false
				addMessage({ description: 'Configurações salvas com sucesso', type: 'success' })
			})
			.catch(() => {
				updating.value = false
				addMessage({
					description: 'Não foi possível salvar as Configurações. Por favor, tente novamente',
					type: 'error',
				})
			})
	}

	onMounted(async () => {
		const response = await buscarConfiguracoesDoAplicativo()
		const configuracoes = response.data.result

		//guarda o id
		idConfiguracao.value = configuracoes.id

		//configuracoes de inventario
		inventario.value.config_app_nr_mdco_nrcd = configuracoes.config_app_nr_mdco_nrcd
		inventario.value.config_app_tx_mdco_tpmd = configuracoes.config_app_tx_mdco_tpmd
		inventario.value.config_app_yn_mdco_arvs_count = configuracoes.config_app_yn_mdco_arvs_count
		inventario.value.config_app_tx_tipo_intensidade = configuracoes.config_app_tx_tipo_intensidade

		//configuracoes de cubagem
		cubagem.value.config_app_tx_cbgm_tpmd = configuracoes.config_app_tx_cbgm_tpmd
		cubagem.value.config_app_nr_cbgm_nrcd = configuracoes.config_app_nr_cbgm_nrcd

		//configuracoes de pilha
		pilha.value.config_app_tx_pilha_tpmd = configuracoes.config_app_tx_pilha_tpmd
		pilha.value.config_app_nr_numero_de_casas_decimais =
			configuracoes.config_app_nr_numero_de_casas_decimais
		pilha.value.config_app_nr_numero_de_diametros_obrigatorio =
			configuracoes.config_app_nr_numero_de_diametros_obrigatorio
		pilha.value.config_app_nr_altura_maxima = configuracoes.config_app_nr_altura_maxima
		pilha.value.config_app_nr_altura_minima = configuracoes.config_app_nr_altura_minima
		pilha.value.config_app_nr_largura_maxima = configuracoes.config_app_nr_largura_maxima
		pilha.value.config_app_nr_largura_minima = configuracoes.config_app_nr_largura_minima
		pilha.value.config_app_diametro_maximo = configuracoes.config_app_diametro_maximo
		pilha.value.config_app_diametro_minimo = configuracoes.config_app_diametro_minimo
	})

	return { inventario, cubagem, pilha, atualizarConfiguracoes, updating }
}
